export default __webpack_public_path__ + "static/media/section1-measure1.5f6a8fc1.svg";